<template>
  <FormItem :label="label" :required="!!required">
    
    <template v-if="editable">
    <RadioGroup :value="strValue" @input="$emit('input',$event)">
      <div class="flex-wrap" style="flex-wrap:wrap;gap:5px">
      <template v-for="o in options">
          <Radio :label="o.key" :key="o.key" :disabled="!editable" :border="config.border" :value="o.key" style="margin-right:40px;">
            <Icon v-if="o.icon" :type="o.icon"></Icon>
            <span>{{o.name}}({{ o.value }})</span>
        </Radio>
      </template>
      </div>
    </RadioGroup>
  </template>
    <template v-else>
      <div>{{val_objects}}</div>
    </template>
 </FormItem>
</template>

<script>
import defaultValueMixin from '../mixins/default-value';
export default {
  mixins: [defaultValueMixin],
  cname: '单选框',
  icon: 'danxuan',
  corder: 40,
  properties: [{
    label: '选项',
    key: 'options',
    control: 'SelectOption',
  }, {
    label: '简易选项',
    key: 'simple',
    control: 'Check',
  }, {
    label: '边框',
    key: 'border',
    control: 'Check',
  },{
    label:'值类型',
    key:'value-type',
    control:'Select',
    option:{
      options:[{
        label:'字符串',
        value:'string',
      },{
        label:'数字',
        value:'number',
      }],
      defaultTo:'string'
    },
  }, {
    label: 'URL',
    key: 'url',
    control: 'Text',
  }],
  props: ['fkey', 'config', 'value', 'editable', 'label', 'required'],
  initModel(e) {
    if (!e.config || !e.config.options) {
      e.config = {
        border: false,
        simple: true,
        options: ['选项1', '选项2'],
        url: '',
        'value-type': 'string',
      };
    } else {
      e.config = {
        options: e.config.options || ['选项1', '选项2'],
        url: e.config.url,
        border: e.config.border,
        simple: e.config.simple,
        multiple: e.config.multiple,
        'value-type': e.config['value-type'] || 'string',
      };
    }
  },
  computed: {
    strValue() {
      if (this.value !== undefined) {
        const value = this.value || 0;
        return value
      }
    },
    val_objects() {
      let v = this.value
      if(typeof v === 'boolean') 
        v = v ? 1 : 0;
      return (this.options.find((t)=>t.key == v) || {}).name;
    },
    options() {
      let options = this.config.options;
      let valueMap = {
        number:(t)=>{
          if(typeof t === 'boolean'){
            return t ? 1 : 0;
          }else if(typeof t == 'string'){
            return parseInt(t);
          }
          return t;
        },
        string:(t)=>{
          if(typeof t === 'boolean'){
            return t ? 'true' : 'false';
          }else if(typeof t == 'number'){
            return t.toString();
          }
          return t;
        },
        boolean:(t)=>{
          if(typeof t === 'string'){
            return t === 'true' || t!=='false';
          }else if(typeof t == 'number'){
            return t > 0;
          }
          return t;
        },
      }
      if (Array.isArray(options)) {
        let mapper = valueMap[this.config['value-type']]
        if (options && typeof options[0] != 'object') {
          options = options.map((v, i)=>({
            key: i,
            name: v,
            value:v
          }));
        }else{
          console.log(options)
          options = options.map((v, i)=>({
            key: v.key,
            name: v.name,
            value:mapper?mapper(v.value || v.key):v.value || v.key
          }));
        }
      }
      if (this.config.simple) {
        options = options.map((v)=>({key: v.name, name: v.name,value:v.name}));
      }
      return options;
    },
  },
};
</script>

<style lang="less">
.l-full{
  position: relative;
  height:100%;
  width:100%;
}
</style>
